import { action } from 'satcheljs/lib/legacy';
import { createNewFolderService } from 'owa-folders';
import store from '../store/store';
var addNewFolderToStore = action('addNewFolderToStore')(function addNewFolderToStore(responseMessage, parentFolderId, displayName) {
    var folderResponse = responseMessage.Folders[0];
    var folderToAddToStore = {
        childFolderIds: [],
        displayName: displayName,
        folderId: folderResponse.FolderId.Id,
        folderType: folderResponse.__type,
        isHidden: false,
        parentFolderId: parentFolderId,
        parentFolderDisplayName: '' /* adding folder to root */,
    };
    // add to end of array since new folders are added to the root
    store.contextMenuFolders.push(folderToAddToStore);
    return Promise.resolve(folderResponse.FolderId.Id);
});
export default function createNewFolder(displayName, parentFolderId) {
    displayName = (displayName || '').trim(); // Do not allow whitespaces.
    return createNewFolderService(parentFolderId, displayName).then(function (responseMessage) {
        if (responseMessage.ResponseClass == 'Success') {
            return addNewFolderToStore(responseMessage, parentFolderId, displayName);
        }
        else {
            throw new Error(responseMessage.MessageText);
        }
    });
}
//# sourceMappingURL=createNewFolderInboxRules.js.map